export const dashboardConstants = {
  LOAD: 'dashboard/LOAD',
  LOAD_SUCCESS: 'dashboard/LOAD_SUCCESS',
  LOAD_FAIL: 'dashboard/LOAD_FAIL',
  GET_LIST: 'dashboard/GET_LIST',
  FILL_TOP_MATCHES: 'dashboard/FILL_TOP_MATCHES',
};
